import { useMemo } from "react";
import PropTypes from "prop-types";

const HomeIndicator = ({
  className = "",
  homeIndicatorBackgroundColor,
  homeIndicatorMargin,
  homeIndicatorPosition,
  homeIndicatorRight,
  homeIndicatorBottom,
  homeIndicatorLeft,
  homeIndicatorTop,
  homeIndicatorMarginTop,
}) => {
  const homeIndicatorStyle = useMemo(() => {
    return {
      backgroundColor: homeIndicatorBackgroundColor,
      margin: homeIndicatorMargin,
      position: homeIndicatorPosition,
      right: homeIndicatorRight,
      bottom: homeIndicatorBottom,
      left: homeIndicatorLeft,
      top: homeIndicatorTop,
      marginTop: homeIndicatorMarginTop,
    };
  }, [
    homeIndicatorBackgroundColor,
    homeIndicatorMargin,
    homeIndicatorPosition,
    homeIndicatorRight,
    homeIndicatorBottom,
    homeIndicatorLeft,
    homeIndicatorTop,
    homeIndicatorMarginTop,
  ]);

  return (
    <footer
      className={`w-[440px] h-[34px] flex flex-row items-start justify-start pt-[21px] px-36 pb-2 box-border z-[3] ${className}`}
      style={homeIndicatorStyle}
    >
      <div className="w-[152px] relative rounded-81xl bg-dark-text h-[5px]" />
    </footer>
  );
};

HomeIndicator.propTypes = {
  className: PropTypes.string,

  /** Style props */
  homeIndicatorBackgroundColor: PropTypes.string,
  homeIndicatorMargin: PropTypes.string,
  homeIndicatorPosition: PropTypes.string,
  homeIndicatorRight: PropTypes.string,
  homeIndicatorBottom: PropTypes.string,
  homeIndicatorLeft: PropTypes.string,
  homeIndicatorTop: PropTypes.string,
  homeIndicatorMarginTop: PropTypes.string,
};

export default HomeIndicator;
